import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer legale pubblico — usato in login, registrazione, home, e nelle pagine policy.
 * Contiene dati aziendali (Art. 2250 c.c.) e link alle policy Iubenda.
 */
export default function LegalFooter({ variant = "light" }) {
  const isDark = variant === "dark";
  const text = isDark ? "text-white/70" : "text-[var(--mp-muted)]";
  const link = isDark
    ? "text-white hover:text-white/70 underline-offset-2 hover:underline"
    : "text-[var(--mp-ink)] hover:text-[var(--mp-primary)] underline-offset-2 hover:underline";
  const border = isDark ? "border-white/10" : "border-[var(--mp-border)]";

  return (
    <footer
      data-testid="legal-footer"
      className={`border-t ${border} px-6 sm:px-10 py-6 ${text} text-[11px] leading-relaxed`}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="space-y-0.5">
          <div>
            <strong className={isDark ? "text-white" : "text-[var(--mp-ink)]"}>
              Marketing Parrucchieri SRL
            </strong>
            {" · "}Via Prestinari 4, 20080 Besate (MI)
          </div>
          <div>
            P.IVA 11579150969{" · "}
            <a
              href="mailto:info@marketingparrucchieri.info"
              className={link}
              data-testid="legal-footer-email"
            >
              info@marketingparrucchieri.info
            </a>
            {" · "}PEC: marketingparrucchieri@legalmail.it
          </div>
        </div>

        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link
            to="/privacy-policy"
            className={link}
            data-testid="legal-footer-privacy"
          >
            Privacy Policy
          </Link>
          <Link
            to="/cookie-policy"
            className={link}
            data-testid="legal-footer-cookies"
          >
            Cookie Policy
          </Link>
          <Link
            to="/note-legali"
            className={link}
            data-testid="legal-footer-notes"
          >
            Note Legali
          </Link>
          <Link
            to="/come-funziona-lai"
            className={link}
            data-testid="legal-footer-ai"
          >
            AI: come la usiamo
          </Link>
          <button
            type="button"
            onClick={() => {
              if (window._iub && window._iub.cs && window._iub.cs.api) {
                window._iub.cs.api.openPreferences();
              }
            }}
            className={`${link} cursor-pointer bg-transparent border-0 p-0`}
            data-testid="legal-footer-cookie-prefs"
          >
            Preferenze cookie
          </button>
        </nav>
      </div>
    </footer>
  );
}
